__webpack_require__.p = "https://resultadoavaliacoes.s.plurall.net/";